import ActionTypes from "../constants/ActionTypes";
import axiosInstance from "../helpers/refreshTokenMiddleware";
import BASE_URL from '../constants/Api';

/* =========================================================
 * タイトル検索処理
 * ========================================================= */
export const fetchSearchRequest = () => ({
  type: ActionTypes.FETCH_SEARCH_REQUEST,
});

export const fetchSearchSuccess = (data, count) => ({
  type: ActionTypes.FETCH_SEARCH_SUCCESS,
  payload: { data, count },
});

export const fetchSearchFailure = (error) => ({
  type: ActionTypes.FETCH_SEARCH_FAILURE,
  payload: error,
});

export const fetchSearchData = (title) => async (dispatch, getState) => {
  dispatch(fetchSearchRequest());
  try {
    const response = await axiosInstance.post(`${BASE_URL}/top/title-search`, {
      title: title || "",
    });

    const { data } = response.data.respons || {};

    dispatch(fetchSearchSuccess(data, data?.length || 0));
    return { data, count: data?.length || 0 };
  } catch (error) {
    console.error("fetchSearchData error:", error);
    dispatch(fetchSearchFailure(error.message || "検索中にエラーが発生しました。"));
  }
};